// extracted by mini-css-extract-plugin
export default {"wrapper":"TrashIcon_wrapper__yG+X0","trashIcon":"TrashIcon_trashIcon__b2hka"};